import * as types from "../types";
import { apolloClient } from "@/plugins/apollo";
import {
    POT_SIZES_QUERY,
    SINGLE_POT_SIZE_QUERY,
    CREATE_POT_SIZE_MUTATION,
    UPDATE_POT_SIZE_MUTATION,
    DELETE_POT_SIZE_MUTATION
} from "@/graphql/potSizes.js";

const state = {
    potSizes: []
};

const getters = {};

const mutations = {
    [types.SET_POT_SIZES](state, potSizes) {
        state.potSizes = potSizes;
    },
    [types.SORT_POT_SIZES](state) {
        state.potSizes.sort(function(a, b) {
            return a.node.potSizeCm == b.node.potSizeCm
                ? 0
                : a.node.potSizeCm > b.node.potSizeCm
                ? 1
                : -1;
        });
    },
    [types.UPSERT_POT_SIZE](state, potSize) {
        var index = state.potSizes.findIndex(function(element) {
            return element.node.id == potSize.id;
        });

        const node = { node: potSize };

        if (index > -1) {
            state.potSizes.splice(index, 1, node);
        } else {
            state.potSizes.unshift(node);
        }
    },
    [types.DELETE_POT_SIZE](state, potSize) {
        var index = state.potSizes.find(function(element, index) {
            if (element.id == potSize.id) {
                return index;
            }
        });

        if (index > -1) {
            state.potSizes.splice(index, 1);
        }
    }
};

const actions = {
    async fetchPotSizes(context) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: POT_SIZES_QUERY,
                    fetchPolicy: "cache-first"
                })
                .then(response => {
                    const potSizes = response.data.tenantPotSizes.edges;

                    // update store
                    context.commit(types.SET_POT_SIZES, potSizes);

                    // sort
                    context.commit(types.SORT_POT_SIZES);

                    resolve(potSizes);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async fetchSinglePotSize(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: SINGLE_POT_SIZE_QUERY,
                    fetchPolicy: "network-only",
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const potSize = JSON.parse(
                        JSON.stringify(response.data.potSize)
                    );

                    // update store
                    context.commit(types.UPSERT_POT_SIZE, potSize);

                    // sort
                    context.commit(types.SORT_POT_SIZES);

                    resolve(potSize);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async createPotSize(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CREATE_POT_SIZE_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const potSize = response.data.createPotSize.potSize;

                    // update store
                    context.commit(types.UPSERT_POT_SIZE, potSize);

                    // sort
                    context.commit(types.SORT_POT_SIZES);

                    resolve(potSize);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async updatePotSize(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UPDATE_POT_SIZE_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const potSize = response.data.updatePotSize.potSize;

                    // update store
                    context.commit(types.UPSERT_POT_SIZE, potSize);

                    // sort
                    context.commit(types.SORT_POT_SIZES);

                    resolve(potSize);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    },

    async deletePotSize(context, payload) {
        return new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: DELETE_POT_SIZE_MUTATION,
                    variables: {
                        input: payload
                    }
                })
                .then(response => {
                    const potSize = response.data.deletePotSize.potSize;

                    // update store
                    context.commit(types.DELETE_POT_SIZE, potSize);

                    resolve(potSize);
                })
                .catch(error => {
                    // console.log(error);
                    reject(error);
                });
        });
    }
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
